"use client";
import React, { ButtonHTMLAttributes, MouseEventHandler } from "react";
import Link, {LinkProps} from "next/link";
import { usePathname, useSearchParams } from "next/navigation";

export default function TabBar({children} : {children?: React.ReactNode}) {
  return <div className="flex justify-center lg:justify-start">
    <div className="tab-bar pt-4 pb-0 -m-4 mb-0 scroll-pl-2">
      {children}
    </div>
  </div>
}

interface TabBarTabType extends LinkProps {
  href: string,
  tabParam?:string,
  ignoreTabParam?:boolean,
  isMainTab?: boolean,
  className?: string,
  children?: React.ReactNode
}

export function TabBarTab({href, tabParam, ignoreTabParam, isMainTab, className, children, ...attributes} : TabBarTabType) {
  const pathname = usePathname()
  const pathTabParam = useSearchParams().get("tab")
  const isActive = pathTabParam && !ignoreTabParam ? pathTabParam == tabParam : (isMainTab ? pathname === href : (pathname.startsWith(href)))
  return <Link
    replace
    href={href}
    className={`
      tab-bar__tab
      ${
        isActive
          ? "tab-bar__tab--active"
          : ""
      }
      ${className || ""}
  `}
   {...attributes}
  >
    <div className="tab-bar__tab-content">
      {children}
    </div>
</Link>
};


interface TabBarTabButtonType extends ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean,
  className?: string,
  children?: React.ReactNode,
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export function TabBarTabButton({isActive, className, onClick, children, ...attributes} : TabBarTabButtonType) {
  return <button
    className={`
      tab-bar__tab
      ${
        isActive
          ? "tab-bar__tab--active"
          : ""
      }
      ${className || ""}
  `}
    onClick={onClick}
   {...attributes}
  >
    <div className="tab-bar__tab-content">
      {children}
    </div>
</button>
}
